module.exports = __webpack_public_path__ + "media/src/application/media/banner_img-01631040c73b01b13feda839311a9b1b.webp";